import { useContext, useEffect, useMemo, useState } from "react";
import "./Slider.css";
import UniCarSearch from "../Cars/UniCarSearch";
import DashboardAccount from "../../Components/Home/DashboardAccount";
import { ConfigContext } from "../../Context/ConfigContext";
import { axiosGet } from "../../Apis/axiosMethods";

const Slider = () => {
  const { business_id } = useContext(ConfigContext);

  const [businessInfo, setBusinessInfo] = useState({});
  const [dashboardData, setDashboardData] = useState({});
  const [statements, setStatements] = useState([]);

  const statementData = useMemo(() => {
    if (!statements.length) {
      return {
        statementDueDays: 0,
        statementDueDate: null,
        statementDueAmount: 0
      };
    }

    let lastStatement = statements[0];

    for (let i = 1; i < statements.length; i++) {
      if (
        new Date(statements[i].statement_from) >
        new Date(lastStatement.statement_from)
      ) {
        lastStatement = statements[i];
      }
    }

    if (lastStatement?.statement_status !== 0) {
      return {
        statementDueDays: 0,
        statementDueDate: null,
        statementDueAmount: 0
      };
    }

    const dueDate = new Date(lastStatement.due_date);
    const today = new Date();

    today.setHours(0, 0, 0, 0);
    dueDate.setHours(0, 0, 0, 0);

    const timeDiff = dueDate.getTime() - today.getTime();
    const statementDueDays = Math.ceil(
      timeDiff / (1000 * 60 * 60 * 24)
    );

    return {
      statementDueDays,
      statementDueDate: dueDate.toLocaleDateString("en-GB"),
      statementDueAmount: Number(lastStatement.total_amount) || 0
    };
  }, [statements]);

  useEffect(() => {
    if (!business_id) return;

    let cancelled = false;

    const getBusinessInfo = async () => {
      try {
        const response = await axiosGet(`/Users/GetBusinessInfo`, { business_id });

        if (cancelled) return;

        if (response?.data?.success) {
          setBusinessInfo(response?.data?.data?.[0] || {});
          setDashboardData(response?.data);
          setStatements(Array.isArray(response?.data?.accounts__statement) ? response?.data.accounts__statement : []);
        } else {
          setStatements([]);
        }
      } catch (error) {
        if (!cancelled) {
          console.error("GetBusinessInfo Error:", error);
          setStatements([]);
        }
      }
    };

    getBusinessInfo();

    return () => {
      cancelled = true;
    };
  }, [business_id]);

  const {
    statementDueDays,
    statementDueDate,
    statementDueAmount
  } = statementData;

  if (window.innerWidth <= 768) {
    return (
      <main className="main prevent-select">
        <div className="row justify-content-center">
          <div className="col-md-3 pl-4 pr-4">
            <UniCarSearch redirectURL="/Spare-Parts/Catelog" />
          </div>

          <div className="col-md-3 pl-4 pr-4"></div>
          <div className="col-md-3 pl-4 pr-4"></div>
        </div>
      </main>
    );
  }

  return (
    <main className="main prevent-select">
      <div className="row justify-content-center">
        <div
          className="col-md-3"
          style={{
            width: "430px",
            flex: "0 0 430px",
            maxWidth: "430px"
          }}
        >
          <UniCarSearch redirectURL="/Spare-Parts/Catelog" />
        </div>

        <DashboardAccount
          businessInfo={businessInfo}
          statementDueAmount={statementDueAmount}
          dashboardData={dashboardData}
          statementDueDays={statementDueDays}
          statementDueDate={statementDueDate}
        />
      </div>
    </main>
  );
};

export default Slider;